import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { useDispatch, useSelector } from 'react-redux';
import AutosuggestComponent from '../public/AutosuggestComponent';
import {
  setIndustryAction,
  setOrganisationAction,
  setDemographicAction,
  setHomeAction,
  setAudienceBuilderDataSoruce,
  setAudienceDateRange,
  createAudience,
} from '../../store/actions/audienceBuilder-actions';

import {
  isEmptyArray,
  arrayUnique,
  sortArrayAlphabetically,
  searchStringInObjectArray,
} from '../../utilities/helpers';

import { demographicList } from '../../data/demographics';

const AudienceCriteria = (props) => {
  const dispatch = useDispatch();

  // data props
  const audienceType = useSelector(
    (state) => state.audienceBuilder.audienceType
  );
  const industries = useSelector((state) => state.audienceBuilder.industry);
  const organisationList = useSelector((state) => {
    let footfallArray;
    let mobileDeviceArray;
    // combine 2 organisation list
    state.reports.reports.forEach((item) => {
      if (item.name === 'footfall') {
        footfallArray = item.organisation;
      } else if (item.name === 'mobileDevices') {
        mobileDeviceArray = item.organisation;
      }
    });

    // Filter duplicate organisation and sort alphabetically

    if (!isEmptyArray(mobileDeviceArray)) {
      const uniqueArray = arrayUnique(footfallArray.concat(mobileDeviceArray));
      const sortedArray = sortArrayAlphabetically(uniqueArray);
      return sortedArray;
    }
    return footfallArray;
  });
  const industryList = useSelector((state) => {
    let footfallArray;
    let mobileDeviceArray;
    // check the correct options
    state.reports.reports.forEach((item) => {
      if (item.name === 'footfall') {
        footfallArray = item.audienceBuilderIndustryOptions.concat();
      } else if (item.name === 'mobileDevices') {
        mobileDeviceArray = item.audienceBuilderIndustryOptions.concat();
      }
    });

    if (mobileDeviceArray) {
      mobileDeviceArray.map((item) => {
        const searchResult = searchStringInObjectArray(
          item.label,
          footfallArray,
          'name'
        );

        if (searchResult) {
          // if category is there. insert into array
          footfallArray[searchResult.idx].options.concat(item.options);
        } else {
          // if not,create one.
          footfallArray.push(item);
        }
      });
    }

    return footfallArray;
  });

  const demographics = useSelector((state) =>
    state.audienceBuilder.genders.concat(state.audienceBuilder.ageBuckets)
  );

  const organisations = useSelector(
    (state) => state.audienceBuilder.organisation
  );
  const dataSource = useSelector((state) => state.audienceBuilder.dataSource);
  const propsHome = useSelector((state) => state.audienceBuilder.home);
  const since = useSelector((state) => state.audienceBuilder.since);
  const until = useSelector((state) => state.audienceBuilder.until);
  const audienceCreating = useSelector(
    (state) => state.audienceBuilder.audienceCreating
  );

  // data value
  const [industry, setIndustry] = useState(industries);
  const [organisation, setOrganisation] = useState(organisations);
  const [demographic, setDemographic] = useState(demographics);
  const [home, setHome] = useState(propsHome);
  const [dataRadioSource, setDataRadioSource] = useState('all');
  const [dateRange, setDateRange] = useState({
    since,
    until,
  });

  // interactive
  const [focusedInput, setFocusedInput] = useState(null);
  const [isTypeAvailable, setIsTypeAvailable] = useState(true);
  const [isBoundariesUpdateAvailable, setIsBoundariesUpdateAvailable] =
    useState(true);

  useEffect(() => {
    dispatch(setAudienceBuilderDataSoruce('all'));

    // set date as default
    dispatch(
      setAudienceDateRange(
        moment().subtract(365, 'days').startOf('day').format(),
        moment().subtract(1, 'days').startOf('day').format()
      )
    );

    setDateRange({
      since: moment().subtract(365, 'days').startOf('day').format(),
      until: moment().subtract(1, 'days').startOf('day').format(),
    });
  }, []);

  const handleIndustryChange = (e) => {
    setIndustry(e);
    dispatch(setIndustryAction(e));
    setIsTypeAvailable(false);
  };

  const handleOrganisationChange = (e) => {
    setOrganisation(e);
    dispatch(setOrganisationAction(e));
    setIsTypeAvailable(false);
  };

  const handleDemographicsChange = (e) => {
    setDemographic(e);
    dispatch(setDemographicAction(e));
    setIsTypeAvailable(false);
  };

  const handleHomeChange = (e) => {
    setHome(e);
    dispatch(setHomeAction(e));
    setIsBoundariesUpdateAvailable(false);
  };

  const handleSetDateRange = ({ startDate: sinceDate, endDate: untilDate }) => {
    if (sinceDate && untilDate) {
      dispatch(
        setAudienceDateRange(
          sinceDate.startOf('day').format(),
          untilDate.endOf('day').format()
        )
      );

      setDateRange({
        since: sinceDate.startOf('day'),
        until: untilDate.endOf('day'),
      });
      props.loadData();
    }
  };

  const handleDataSourceChange = (e) => {
    setDataRadioSource(e.target.value);
    dispatch(setAudienceBuilderDataSoruce(e.target.value));
    props.loadData();
  };

  const isOutsideRangeHandler = (selectedDate) => {
    const today = moment();
    return (
      !selectedDate.isSameOrBefore(today) ||
      !selectedDate.isSameOrAfter(today.add(-12, 'months'))
    );
  };

  const handleRebuildAudience = () => {
    setIsTypeAvailable(true);
    setIsBoundariesUpdateAvailable(true);
    props.loadData();
  };

  const renderCalendarInfo = () => {
    const handleClick = (datePeriod) => {
      dispatch(
        setAudienceDateRange(
          moment().subtract(datePeriod, 'days').startOf('day').format(),
          moment().subtract(1, 'days').startOf('day').format()
        )
      );

      setFocusedInput(false);
      setDateRange({
        since: moment().subtract(datePeriod, 'days').startOf('day').format(),
        until: moment().subtract(1, 'days').startOf('day').format(),
      });

      props.loadData();
    };

    return (
      <div>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(30)}
        >
          {' '}
          Last 30 days
        </button>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(90)}
        >
          {' '}
          Last 90 days
        </button>
        <button
          className="quickSelectDatePeriod"
          onClick={() => handleClick(365)}
        >
          {' '}
          Last 12 months
        </button>
      </div>
    );
  };

  const handleActivateButton = () => {
    props.toggleModal(true);
    dispatch(createAudience(props.clientId));
  };

  return (
    <div className="Audience_content content-card">
      <div className="Audience_criteria">
        {audienceType === 'subcategory' && (
          <React.Fragment>
            <h3 style={{ fontSize: '1.125rem' }}>Selected Industry</h3>
            <div style={{ display: 'flex' }}>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isTypeAvailabled={false}
                isClearable
                isMulti
                isRtl={false}
                isSearchable
                options={industryList}
                value={industry}
                onChange={(event) => handleIndustryChange(event)}
              />

              <div style={{ marginLeft: '1rem' }}>
                <UpdateButton
                  handleRebuildAudience={handleRebuildAudience}
                  disabled={isTypeAvailable}
                />
              </div>
            </div>
          </React.Fragment>
        )}

        {audienceType === 'organization' && (
          <React.Fragment>
            <h3 style={{ fontSize: '1.125rem' }}>Selected Brand</h3>
            <div style={{ display: 'flex' }}>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isTypeAvailabled={false}
                isClearable
                isRtl={false}
                isMulti
                isSearchable
                options={organisationList}
                value={organisation}
                onChange={(event) => handleOrganisationChange(event)}
              />
              <div style={{ marginLeft: '1rem' }}>
                <UpdateButton
                  handleRebuildAudience={handleRebuildAudience}
                  disabled={isTypeAvailable}
                />
              </div>
            </div>
          </React.Fragment>
        )}

        {audienceType === 'demographic' && (
          <React.Fragment>
            <h3 style={{ fontSize: '1.125rem' }}>Selected Demographics</h3>
            <div style={{ display: 'flex' }}>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isTypeAvailabled={false}
                isClearable
                isRtl={false}
                isMulti
                isSearchable
                options={demographicList}
                value={demographic}
                onChange={(event) => handleDemographicsChange(event)}
              />
              <div style={{ marginLeft: '1rem' }}>
                <UpdateButton
                  handleRebuildAudience={handleRebuildAudience}
                  disabled={isTypeAvailable}
                />
              </div>
            </div>
          </React.Fragment>
        )}

        {audienceType !== 'home' && audienceType !== 'demographic' && (
          <React.Fragment>
            <h3
              className="content-card_title"
              style={{ paddingTop: '2rem', paddingBottom: '1rem' }}
            >
              Additional filters
            </h3>

            <h3 style={{ fontSize: '1rem', color: '#697689' }}>Date range</h3>

            <DateRangePicker
              displayFormat="DD MMM YYYY"
              startDate={moment(dateRange.since)} // momentPropTypes.momentObj or null,
              startDateId="your_unique_start_date_id-8294793847289" // PropTypes.string.isRequired,
              endDate={moment(dateRange.until)} // momentPropTypes.momentObj or null,
              endDateId="your_unique_end_date_id-8294793847289" // PropTypes.string.isRequired,
              onDatesChange={handleSetDateRange} // PropTypes.func.isRequired,
              focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={(input) => setFocusedInput(input)} // PropTypes.func.isRequired,
              isOutsideRange={isOutsideRangeHandler}
              minimumNights={0}
              calendarInfoPosition="bottom"
              renderCalendarInfo={renderCalendarInfo}
            />

            <div style={{ paddingTop: '1rem' }}>
              <h3 style={{ fontSize: '1rem', color: '#697689' }}>
                Data source
              </h3>
              <label
                className="PartnerInsights_edit-reports_list_label"
                htmlFor="report-id-1"
                style={{ marginRight: '1rem' }}
              >
                <input
                  className="PartnerInsights_edit-reports_list_radio"
                  type="radio"
                  name="all"
                  id="report-id-1"
                  value="all"
                  checked={dataRadioSource === 'all'}
                  onClick={(e) => handleDataSourceChange(e)}
                />
                <span
                  className="PartnerInsights_edit-reports_list_title"
                  style={{ color: ' rgb(105, 118, 137)', fontWeight: 500 }}
                >
                  All
                </span>
              </label>
              <label
                className="PartnerInsights_edit-reports_list_label"
                htmlFor="report-id-2"
                style={{ marginRight: '1rem' }}
              >
                <input
                  className="PartnerInsights_edit-reports_list_radio"
                  type="radio"
                  name="location"
                  id="report-id-2"
                  value="location"
                  checked={dataRadioSource === 'location'}
                  onClick={(e) => handleDataSourceChange(e)}
                />
                <span
                  className="PartnerInsights_edit-reports_list_title"
                  style={{ color: ' rgb(105, 118, 137)', fontWeight: 500 }}
                >
                  Location
                </span>
              </label>
              <label
                className="PartnerInsights_edit-reports_list_label"
                htmlFor="report-id-3"
              >
                <input
                  className="PartnerInsights_edit-reports_list_radio"
                  type="radio"
                  name="mobileDevice"
                  id="report-id-3"
                  value="mobileDevice"
                  checked={dataRadioSource === 'mobileDevice'}
                  onClick={(e) => handleDataSourceChange(e)}
                />
                <span
                  className="PartnerInsights_edit-reports_list_title"
                  style={{ color: ' rgb(105, 118, 137)', fontWeight: 500 }}
                >
                  Mobile Device
                </span>
              </label>
            </div>
          </React.Fragment>
        )}

        {audienceType !== 'demographic' && (
          <div style={{ display: 'flex' }}>
            <div style={{ width: '100%' }}>
              <h3
                style={{
                  fontSize: '1rem',
                  paddingTop: '1rem',
                  color: '#697689',
                }}
              >
                Customers home location
              </h3>
              <div>
                <AutosuggestComponent
                  handleHomeChange={handleHomeChange}
                  data={home}
                />
              </div>
            </div>
            <div style={{ marginTop: '2.7rem', marginLeft: '1rem' }}>
              <UpdateButton
                handleRebuildAudience={handleRebuildAudience}
                disabled={isBoundariesUpdateAvailable}
              />
            </div>
          </div>
        )}

        <div style={{ textAlign: 'center', paddingTop: '4rem' }}>
          <button
            onClick={() => handleActivateButton()}
            className="Header_create-location-insights-button"
            disabled={audienceCreating}
            style={{ minWidth: '10rem', padding: '0.4rem 1.75rem' }}
          >
            Activate
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudienceCriteria;

const UpdateButton = (props) => (
  <button
    onClick={() => props.handleRebuildAudience()}
    className="Header_create-location-insights-button"
    disabled={props.disabled}
    style={{
      padding: '0.4rem 1rem',
      backgroundColor: props.disabled ? '#CCC' : '#32ABE1',
    }}
  >
    Update
  </button>
);
